import { LingEntity } from './ling-entity';
import { CertificateGeneralSection } from './certificate';

export class Edition extends LingEntity {
  name?: string;
  total?: number;
  limit?: number;
  limited?: boolean;
  creator?: string;
  owner?: string;
  containsCreated?: boolean;
  containsMinted?: boolean;
  containsReleased?: boolean;
  containsClaimed?: boolean;
  isFull?: boolean;
  general?: CertificateGeneralSection;

  constructor(edition?: Edition) {
    super(edition);
    if (edition) {
      Object.assign(this, edition);
    }
  }

  get canBeEdited(): boolean {
    return !(
      this.containsMinted ||
      this.containsReleased ||
      this.containsClaimed
    );
  }

  get canBeDeleted(): boolean {
    return (
      this.containsCreated ||
      this.containsMinted ||
      this.containsReleased ||
      !this.containsClaimed
    );
  }
}
